var XPortal = XPortal || {};
XPortal.FancyBox = (function () {
    var self = {};

    self.fancyboxselector = '[data-fancybox]';

    self.init = function (fancyboxselector) {
        self.initFancyBox(fancyboxselector ? fancyboxselector : self.fancyboxselector);
    };

    self.initFancyBox = function (fancyboxselector) {
        Fancybox.bind(fancyboxselector, {
            // Options
          });
    };
    return self;
}());